import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import modules from './modules/index';
import VueCookie from 'vue-cookies'
import getters from '@/stores/getters';
import apiService from '@/services/apiService';
import {API_GET_REVIEWING_VERSIONS} from '@/configs/api';

const vuexLocal = new VuexPersistence({
  storage: localStorage,
  modules: ['user_info', 'registerStore', 'sid', 'appVersion', 'currentReport', 'constructionStore', 'softBankStore']
})

Vue.use(Vuex);

let promiseCheckAppVersion = null

export default new Vuex.Store({
  state: {
    routeTimer: 0,
    sid: null,
    user_info: {},
    role: null,
    appVersion: null,
    hideContentByAppVersion: false,
    currentReport: {},
  },
  mutations: {
    RESTORE_MUTATION: vuexLocal.RESTORE_MUTATION,
    SET_SESSION_ID (state) {
      state.sid = VueCookie.get('session_id')
    },
    SET_USER_INFO (state, payload) {
      state.user_info = payload;
    },
    SET_APP_VERSION (state, payload) {
      state.appVersion = payload;
    },
    SET_HIDE_CONTENT_BY_APP_VERSION (state, payload) {
      state.hideContentByAppVersion = payload;
    },
    SET_CURRENT_REPORT (state, payload) {
      state.currentReport = payload;
    },
  },
  modules,
  strict: false,
  getters: {
    getSessionId (state) {
      return state.sid ? state.sid : VueCookie.get('session_id')
    },
    getUserInfo (state) {
      return state.user_info ? state.user_info : {};
    },
    getCurrentReport (state) {
      return state.currentReport;
    },
    ...getters
  },
  actions: {
    logout ({commit}) {
      VueCookie.remove('session_id')
      commit('SET_SESSION_ID', null)
      commit('SET_USER_INFO', {})
      commit('paidPlansStore/CLEAR_DATA');
    },
    login ({commit}) {
      commit('SET_SESSION_ID')
    },
    async checkAppVersion ({state, commit}) {
      if (promiseCheckAppVersion) {
        return promiseCheckAppVersion
      }

      if (state.appVersion) {
        promiseCheckAppVersion = apiService.postWithoutIsCallingFlag(API_GET_REVIEWING_VERSIONS)
        let response = await promiseCheckAppVersion
        if (response.data && response.data.reviewing_versions) {
          if (response.data.reviewing_versions.includes(state.appVersion)) {
            promiseCheckAppVersion = null
            commit('SET_HIDE_CONTENT_BY_APP_VERSION', true, {root: true})
            return true
          }
        }
      }

      promiseCheckAppVersion = null
      commit('SET_HIDE_CONTENT_BY_APP_VERSION', false, {root: true})
      return false
    }
  },
  plugins: [
    vuexLocal.plugin
  ]
});



// WEBPACK FOOTER //
// ./src/stores/index.js